import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'utils/AuthGuard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// art
const ARTPage = Loadable(lazy(() => import('pages/art/index')));

// normativas
const NormativasList = Loadable(lazy(() => import('pages/normativas/index')));
const NormativaForm = Loadable(lazy(() => import('pages/normativas/Form')));
const NormativasView = Loadable(lazy(() => import('pages/normativas/View')));

// usuarios
const UsuariosList = Loadable(lazy(() => import('pages/usuarios/index')));
const UsuarioForm = Loadable(lazy(() => import('pages/usuarios/Form')));
const UsuariosView = Loadable(lazy(() => import('pages/usuarios/View')));

// clientes
const ClientesList = Loadable(lazy(() => import('pages/clientes/index')));
const ClienteForm = Loadable(lazy(() => import('pages/clientes/Form')));
const ClientesView = Loadable(lazy(() => import('pages/clientes/View')));

// equipamentos
const EquipamentosList = Loadable(lazy(() => import('pages/equipamentos/index')));
const EquipamentoForm = Loadable(lazy(() => import('pages/equipamentos/Form')));
const EquipamentosView = Loadable(lazy(() => import('pages/equipamentos/View')));

// perigos
const PerigosList = Loadable(lazy(() => import('pages/perigos/index')));
const PerigoForm = Loadable(lazy(() => import('pages/perigos/Form')));
const PerigosView = Loadable(lazy(() => import('pages/perigos/View')));

// servicos
const ServicosList = Loadable(lazy(() => import('pages/servicos/index')));
const ServicoForm = Loadable(lazy(() => import('pages/servicos/Form')));
const ServicosView = Loadable(lazy(() => import('pages/servicos/View')));

// propostas
const PropostasList = Loadable(lazy(() => import('pages/propostas/index')));
const PropostaForm = Loadable(lazy(() => import('pages/propostas/Form')));
const PropostasView = Loadable(lazy(() => import('pages/propostas/View')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'clientes',
      children: [
        { path: '', element: <ClientesList /> },
        { path: 'novo', element: <ClienteForm /> },
        { path: 'editar/:id', element: <ClienteForm /> },
        { path: 'visualizar/:id', element: <ClientesView /> }
      ]
    },
    {
      path: 'equipamentos',
      children: [
        { path: '', element: <EquipamentosList /> },
        { path: 'novo', element: <EquipamentoForm /> },
        { path: 'editar/:id', element: <EquipamentoForm /> },
        { path: 'visualizar/:id', element: <EquipamentosView /> }
      ]
    },
    {
      path: 'perigos',
      children: [
        { path: '', element: <PerigosList /> },
        { path: 'novo', element: <PerigoForm /> },
        { path: 'editar/:id', element: <PerigoForm /> },
        { path: 'visualizar/:id', element: <PerigosView /> }
      ]
    },
    {
      path: 'normativas',
      children: [
        { path: '', element: <NormativasList /> },
        { path: 'nova', element: <NormativaForm /> },
        { path: 'editar/:id', element: <NormativaForm /> },
        { path: 'visualizar/:id', element: <NormativasView /> }
      ]
    },
    {
      path: 'servicos',
      children: [
        { path: '', element: <ServicosList /> },
        { path: 'novo', element: <ServicoForm /> },
        { path: 'editar/:id', element: <ServicoForm /> },
        { path: 'visualizar/:id', element: <ServicosView /> }
      ]
    },
    {
      path: 'propostas',
      children: [
        { path: '', element: <PropostasList /> },
        { path: 'nova', element: <PropostaForm /> },
        { path: 'editar/:id', element: <PropostaForm /> },
        { path: 'visualizar/:id', element: <PropostasView /> }
      ]
    },
    {
      path: 'laudos',
      element: <SamplePage />
    },
    {
      path: 'art',
      element: <ARTPage />
    },
    {
      path: 'usuarios',
      children: [
        { path: '', element: <UsuariosList /> },
        { path: 'novo', element: <UsuarioForm /> },
        { path: 'editar/:id', element: <UsuarioForm /> },
        { path: 'visualizar/:id', element: <UsuariosView /> }
      ]
    }
  ]
};

export default MainRoutes;
